import { Component, ViewChild } from '@angular/core'
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms'
import { AdminService } from '../../services/admin.service'
import { HttpStatusCode } from '@angular/common/http'

@Component({
  selector: 'app-admin-chats',
  templateUrl: './admin-chats.component.html',
  styleUrls: ['./admin-chats.component.css'],
})
export class AdminChatsComponent {
  @ViewChild(FormGroupDirective) announceFormDirective!: FormGroupDirective

  announceForm = new FormGroup({
    message: new FormControl('', [Validators.required, Validators.minLength(1)]),
    title: new FormControl('', []),
  })
  announceSending = false
  deleteMessageId = new FormControl('', [Validators.required])
  deleting = false

  constructor(public adminService: AdminService) {}

  sendAnnouncement(): void {
    if (this.announceForm.invalid) {
      this.announceForm.markAllAsTouched()
      this.adminService.showNotification('Enter announcement message', 4000, 'Close')
      return
    }
    const message = this.announceForm.get('message')?.value?.trim()
    const title = this.announceForm.get('title')?.value?.trim()
    this.announceSending = true
    this.adminService.announceNational({ message, title: title || undefined }).subscribe({
      next: (res: any) => {
        this.announceSending = false
        if (res.status === HttpStatusCode.Created || res.status === HttpStatusCode.Ok) {
          this.adminService.showNotification('Announcement sent', 3000, 'OK')
          // resetForm() (not announceForm.reset()) also clears the directive's `submitted`
          // flag, which is what Material's default ErrorStateMatcher checks - otherwise the
          // now-empty required `message` field immediately shows a stale "required" error.
          this.announceFormDirective.resetForm()
        }
      },
      error: (err) => {
        this.announceSending = false
        this.adminService.showNotification(err?.error?.message ?? 'Failed to send announcement', 5000, 'Close')
      },
    })
  }

  deleteMessage(): void {
    const id = this.deleteMessageId.value?.trim()
    if (!id) return
    this.deleting = true
    this.adminService.deleteNationalMessage(id).subscribe({
      next: (res: any) => {
        this.deleting = false
        if (res.status === HttpStatusCode.Ok) {
          this.adminService.showNotification('Message deleted', 3000, 'OK')
          this.deleteMessageId.setValue('')
        }
      },
      error: (err) => {
        this.deleting = false
        this.adminService.showNotification(err?.error?.message ?? 'Failed to delete message', 5000, 'Close')
      },
    })
  }
}
